import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError } from 'rxjs/operators';

// POST /api/notification is a courtesy follow-up fired after some other save, and
// several callers close their dialog or navigate only from its success handler.
// The route is permission gated, so an operator without the grant gets a 401 that
// would otherwise strand a save that already succeeded.
export interface FollowUpNotificationResult {
	success: boolean;
	message: string;
	notificationDelivered: boolean;
}

// `success` refers to the save, which did happen. `message` is the Common.* key
// callers render as the toast body, so it must not claim the notification was sent.
export const NOTIFICATION_NOT_DELIVERED: Readonly<FollowUpNotificationResult> = Object.freeze({
	success: true,
	message: 'NotificationNotDelivered',
	notificationDelivered: false,
});

// Lets the caller's success path run when the notification is refused. Emits a
// fresh copy each time so no subscriber can write through to the shared constant.
export function tolerateNotificationFailure<T>(): OperatorFunction<T, T | FollowUpNotificationResult> {
	return (source: Observable<T>) => source.pipe(
		catchError((error) => {
			console.warn('Follow-up notification not delivered', error);
			return of({ ...NOTIFICATION_NOT_DELIVERED });
		}),
	);
}
